module.exports = __webpack_public_path__ + "static/analyse-4408ded8fce5127ef246331e730dc0ea.png";